module.exports = __webpack_public_path__ + "img/5267089726081459339.97ca12fc.jpg";